import { createSlice } from "@reduxjs/toolkit";

export interface Confirmation {
  visible: boolean;
  message?: string;
  loading?: boolean;
  handleValid?: () => void;
}


const initialState = {
  visible: false,
  message: "",
  handleValid: undefined,
  loading: false,
} as Confirmation;

const confirmationSlice = createSlice({
  name: "confirmation",
  initialState,
  reducers: {
    setLoadingConfirmation: (state, action) => {
      state.loading = action.payload;
    },
    showModalConfirmation: (state, action) => {
      state.visible = true;
      state.message = action.payload.message;
      state.handleValid = action.payload.handleValid;
    },
    hideModalConfirmation: (state) => {
      state.visible = false;
      state.handleValid = undefined;
      state.loading = false;
    },
  },
});

export const {
  showModalConfirmation,
  hideModalConfirmation,
  setLoadingConfirmation,
} = confirmationSlice.actions;

export default confirmationSlice.reducer;
